export default __webpack_public_path__ + "static/media/operation-completed.0682156b.svg";